import { useAnalytics } from "@/src/sb/components/Analytics"
import classNames from "classnames"
import React from "react"

import { MenuItemOption } from "../../../constants/copy"
import Menu from "../../Menu"
import { Icon } from "./Icon"

const MENU_SIZES = {
  auto: "h-11 whitespace-nowrap",
  lg: "h-12 whitespace-nowrap"
}

type MenuItemProps<T = Record<string, any>> = {
  // Allow menuItems type to be extended per usecase
  menuItems: Array<MenuItemOption & T>
  size?: keyof typeof MENU_SIZES
  onClick?: (text: string) => void
  onItemClick?: (item: MenuItemOption & T) => void
  trackingContext?: string
}

export const MenuItem = <T = Record<string, any>,>(props: MenuItemProps<T>) => {
  const {
    menuItems,
    size = "auto",
    trackingContext = "",
    onClick,
    onItemClick
  } = props
  const analytics = useAnalytics()

  const itemClassName = classNames(MENU_SIZES[size], "dark:text-xs")
  const navItemClick = (label: string) => () => {
    onClick?.(label)
  }

  return (
    <>
      {menuItems.map((item, index) => {
        if ("type" in item && item.type === "separator") {
          return <hr key={index} className="border-gray-500" />
        }
        const linkItem = item as any
        return (
          <Menu.Link
            key={index}
            href={linkItem.href}
            icon={
              linkItem.icon ? (
                typeof linkItem.icon === "string" ? (
                  <Icon src={linkItem.icon} alt={linkItem.label} />
                ) : (
                  linkItem.icon
                )
              ) : null
            }
            onClick={() => {
              navItemClick(linkItem.label)
              onItemClick?.(item)
              linkItem?.handleClick?.(analytics, { context: trackingContext })
            }}
            className={itemClassName}
          >
            {linkItem.label}
          </Menu.Link>
        )
      })}
    </>
  )
}
